<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <CCard>
    <div
      class="card-header bg-primary font-weight-bold text-white"
      style="display: flex; align-items: center;"
    >
      Data Dokumen Peserta
      <Button
        class="btn btn-md btn-success ml-auto text-white "
        :disabled="cekDisable()"
        style="float:right;margin-right:10px"
        @click="prosesAdministrasi()">
          Proses Administrasi
      </Button>
      <Button
        class="btn btn-md btn-dark d-inline-block float-right text-white"
        @click="$router.go(-1)"
      >Kembali</Button>
      
    </div>
    
    <CCardBody>
      <CRow>
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-3 pr-xl-4 pr-sm-0">
         
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-3">
          <!-- small box -->
          <div class="card border-0">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Nama File</th>
                      <th>Status</th>
                      <th class="text-center" colspan="2">Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value , index) in dokumenPeserta" v-bind:key="index">
                      <td>{{ index+1 }}</td>
                      <td
                        class="w-50 w-sm-100 text-uppercase"
                        style="text-align:left"
                      >{{ value.namaDokumen }}</td>
                      <td
                        class="font-weight-bold text-secondary"
                        v-if="value.statusUpload == '0'"
                      >Belum Upload</td>
                      <td
                        class="font-weight-bold text-success"
                        v-if="value.statusUpload == '1'"
                      >Terverifikasi</td>
                      <td
                        class="font-weight-bold text-primary"
                        v-if="value.statusUpload == '2'"
                      >Sudah Upload</td>
                      <td
                        class="font-weight-bold text-warning"
                        v-if="value.statusUpload == '3'"
                      >File Tidak Terbaca</td>
                      <td
                        class="font-weight-bold text-danger"
                        v-if="value.statusUpload == '4'"
                      >File Tidak Sesuai</td>
                      <td class="text-center">
                        <button
                          class="btn btn-info text-light p-0 px-3 shadow mx-auto"
                          :disabled="value.statusUpload == '0'"
                          v-c-tooltip="'Verifikasi'"
                          @click="verifikasiDokumen(value.idDokumenPendukungRpl,value.statusUpload)"
                        >
                          <small><i class="fa fa-check"  ></i></small>
                        </button>
                      </td>
                      <td class="text-center" style="display:none">
                        <button class="btn btn-success text-light p-0 px-3 shadow mx-auto">
                          <small>Upload</small>
                        </button>
                      </td>
                      <td class="text-center">
                        <button
                          class="btn btn-warning text-light p-0 px-3 shadow mx-auto"
                          :disabled="value.statusUpload == '0' "
                          @click="bukaFile(value.file)"
                          v-c-tooltip="'Lihat File'"
                        >
                          <small><i class="fa fa-eye"  ></i></small>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </CRow>
      <!-- Modal Verifikasi -->
      <CModal
        title="Modal title"
        :show.sync="modalVerif"
        :no-close-on-backdrop="true"
        :centered="true"        
      >
        <CForm>
          <CRow>
            <CCol sm="12">
              <label for class="font-weight-bold">Diverifikasi Pada</label>
              <br />
              <CInput class="font-weight-bold" type="date" v-model="formData.verifikasiPada" />
            </CCol>

            <CCol sm="12 mb-4">
              <label for class="font-weight-bold">Status</label>
              <br />
              <select name="id_outlet" v-model="formData.statusUpload" class="form-control mb-2">
                <option value="0" :selected="formData.statusUpload == '0'">Belum Upload</option>
                <option value="1" :selected="formData.statusUpload == '1'">Terverifikasi</option>
                <option value="2" :selected="formData.statusUpload == '2'">Sudah Upload</option>
                <option value="3" :selected="formData.statusUpload == '3'">File Tidak Terbaca</option>
                <option value="4" :selected="formData.statusUpload == '4'">File Tidak Sesuai</option>
              </select>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Verifikasi Data Anggota</h6>
        </template>
        <template #footer>
          <CButton @click="modalVerif = false" color="danger">Tutup</CButton>
          <CButton type="submit" @click="postData" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
      <CModal
        title="Modal title"
        :show.sync="modalEmail"
        :no-close-on-backdrop="true"
        :centered="true"        
      >
        <CForm>
          <CRow>
            <CCol sm="12">
              <CInput class="font-weight-bold" label="Subjek" placeholder="Masukkan Subjek" />
            </CCol>
            <CCol sm="12">
              <CTextarea
                class="font-weight-bold"
                label="Pesan"
                rows="3"
                placeholder="Masukkan isi pesan"
              />
            </CCol>

            <CCol sm="12 mb-5">
              <label for="uid-zwqayuopq3" class="font-weight-bold">File (Opsional)</label>
              <br />
              <div class="custom-file text-truncate">
                <input type="file" class="custom-file-input" id="validatedCustomFile" />
                <label class="custom-file-label" for="validatedCustomFile">{{ fileName }}.</label>
                <label class="custom-file-label" for="validatedCustomFile">Choose file</label>
              </div>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Kirim Email</h6>
          <CButtonClose @click="modalEmail = false" class="text-white" />
        </template>
        <template #footer class="mt-5">
          <CButton @click="modalEmail = false" color="danger">Tutup</CButton>
          <CButton type="submit" color="success">Kirim</CButton>
        </template>
      </CModal>
    </CCardBody>
  </CCard>
</template>
<script>
import DataKeanggotaanService from "../../../../services/keanggotaan/data-anggota.service";
import DataPesertaRplService from "../../../../services/sertifikasi/data-peserta-rpl.service";
import Utils from "../../../../services/utils.service";
import DataPesertaService from "../../../../services/sertifikasi/data-peserta.service";

export default {
  name: "DataDokumen",
  el: "#app",
  data() {
    return {
      fileName: "Choose File",
      details: {},
      masterDokumen: [],
      dokumenPeserta: [],
      statusVerifikasi : 0,
      formData: {
        idDokumenPendukungPeserta: "",
        statusUpload: "",
        verifikasiPada: new Date().toISOString().slice(0, 10)
      },
      no: 1,
      status: false,
      modalVerif: false,
      modalEmail: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      index: 0,
      content: []
    };
  },
  mounted() {
    this.getData();
    this.formData.idUser = '6693720917447925107';
  },
  methods: {
    cekDisable(){
      if(this.statusVerifikasi == 0) {
        return true;    
      } else {
        return false
      }
    },
    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "errorr",
        showCancelButton: true
      });
    },
    bukaFile(file) {
      let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
width=0,height=0,left=-1000,top=-1000`;
      window.open(
        Utils.baseurlFoUsers() + "/dokumen_persyaratan_sertifikas/" + file,
        file,
        params
      );
    },
    updateDataAnggota() {
      DataKeanggotaanService.updateDataAnggota(
        this.$route.params.id_user,
        this.details
      )
        .then(response => {
          // comment console console.log(response);
          this.alertSuccess();
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },
    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },
    alertVerif() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Verifikasi"
      });
    },
    alertProsess() {  
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Proses administrasi berhasil"
      });
    },
    verifikasiDokumen(idDokumenPendukungRpl, statusUpload, index) {
      this.modalVerif = true;
      this.formData.idDokumenPendukungPeserta = idDokumenPendukungRpl;
      this.formData.statusUpload = statusUpload;
      this.index = index;
    },

    getData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      DataPesertaRplService.detailDataPeserta(
        this.$route.params.id_sertifikasi_rpl_peserta 
      )
        .then(response => {          
          this.dokumenPeserta = response.data.singleData.data_dokumen;
          this.statusVerifikasi = response.data.singleData.status_verifikasi;
          // comment console console.log(response);
          loader.hide();
        })
        .catch(error => {
          // comment console console.log(error);
          loader.hide();
        });

      // comment console console.log("data data data");
      // comment console console.log("sdf" + this.masterDokumen);

      // var arr1 = this.content[0];
      // var arr2 = this.content[1];
      // // comment console console.log("array baru"+arr1)
    },

    postData() {
      var vm = this;
      DataKeanggotaanService.verifikasiDataDokumen(this.formData)
        .then(response => {
          // comment console console.log(response);
          this.modalVerif = false;
          this.alertVerif();
          vm.getData();
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },
    prosesAdministrasi(){
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var formData = {
        id_sertifikasi_rpl_peserta : this.$route.params.id_sertifikasi_rpl_peserta,
        statusKelayakan : '1'
      }
      DataPesertaRplService.putSendProsesAdministrasiRpl(formData)
      .then(response => {
        // comment console console.log(response);
        loader.hide();
        this.alertProsess();
      }).catch(error => {
        loader.hide();
        this.alertError();
        // comment console console.log(error)
      })
    }

  }
};
</script>
